
define('ldsh!modules/form_editor/templates/preview_custom_linlogin', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div id="' +
((__t = ( idName )) == null ? '' : __t) +
'" class="ed-item-socialbox ed-item-socialbox-h ' +
((__t = ( position )) == null ? '' : __t) +
'">\n  <script type="in/Login"\n          class="ed-social-block ed-linkedIn-login size-' +
((__t = ( size )) == null ? '' : __t) +
'"></script>\n</div>\n';

}
return __p
};});

